import React from 'react';
import Footer from '../components/Footer';
import SEOHead from '../seo/SEOHead';
import { PAGE_SEO } from '../seo/seoConfig';


const TermsAndConditions = () => {
  return (
    <>
      <SEOHead
        title={PAGE_SEO.terms.title}
        description={PAGE_SEO.terms.description}
        keywords={PAGE_SEO.terms.keywords}
        canonical={PAGE_SEO.terms.canonical}
        ogImage={PAGE_SEO.terms.ogImage}
      />
      <div className="terms-container">
        <div className="terms-content">
          <h1 className="policy-title">Terms & Conditions</h1>

          <section className="terms-section">
            <h2 className="section-title">1. Acceptance of Terms</h2>
            <p className="section-text">
              By accessing, browsing, or using the RealFlame website (operated by <strong>PEARL PRINT PACK PRIVATE LIMITED</strong>), you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions. If you do not agree with any part of these terms, please do not use our website or services.
            </p>
            <p className="section-text">
              We reserve the right to update or modify these Terms & Conditions at any time without prior notice. Your continued use of the website following any changes constitutes your acceptance of the updated terms.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">2. Website Usage & Acceptable Use Policy</h2>
            <p className="section-text">
              You agree to use our website only for lawful purposes and in a manner that does not infringe the rights of or restrict the use of this website by any third party.
            </p>
            <p className="section-text"><strong>Prohibited activities include:</strong></p>
            <ul className="terms-list">
              <li>Providing false, inaccurate, or misleading contact information.</li>
              <li>Attempting unauthorized access to website servers, databases, or systems.</li>
              <li>Scraping, harvesting, or collecting site data using automated tools.</li>
              <li>Using communication channels (WhatsApp, SMS, Email) to send spam or abusive content.</li>
              <li>Transmitting malware, viruses, or any harmful code.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">3. Product Information & Disclaimers</h2>
            <p className="section-text">
              We strive to ensure that all product descriptions, technical specifications, and imagery on RealFlame are accurate and current. However:
            </p>
            <ul className="terms-list">
              <li><strong>Product Images:</strong> Images are for illustrative purposes. Actual product colors, finishes, or minor packaging details may vary slightly due to lighting or screen settings.</li>
              <li><strong>Specifications & Prices:</strong> Specifications, availability, and prices are subject to change without prior notice.</li>
              <li><strong>Availability:</strong> Listing a product on the website does not guarantee immediate stock availability.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">4. Communication Policy & Meta WhatsApp Consent</h2>
            <p className="section-text">
              By submitting your details via any website form (including the Customer Details Form) and checking the mandatory consent box, you explicitly agree to receive communications from RealFlame:
            </p>
            <ul className="terms-list">
              <li><strong>WhatsApp Communications:</strong> Transactional updates, order notifications, product information, and customer support messages via Meta's WhatsApp Business API.</li>
              <li><strong>SMS & Phone Calls:</strong> Time-sensitive notifications, order validation, and support calls.</li>
              <li><strong>Email Notifications:</strong> Information regarding inquiries, updates, and promotional material (with opt-out option).</li>
            </ul>
            <p className="section-text">
              <em>Compliance with Meta Policies:</em> WhatsApp messaging is conducted strictly in accordance with Meta Platform Terms and Developer Policies. You can opt out of promotional messages at any time by replying "STOP" to WhatsApp or SMS messages.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">5. User Responsibilities</h2>
            <p className="section-text">As a user of our website, you agree to:</p>
            <ul className="terms-list">
              <li>Provide accurate, complete, and current information in all forms.</li>
              <li>Maintain the confidentiality of any information received regarding orders or quotes.</li>
              <li>Be fully responsible for any activity performed using your contact details.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">6. Mandatory Consent Checkbox Clause</h2>
            <p className="section-text">
              Before submitting any form on our site, users are required to check the following consent statement:
            </p>
            <div className="consent-clause-box">
              "I have read and agree to the Privacy Policy and Terms & Conditions and consent to receive communications from RealFlame through WhatsApp, SMS, Email, and Phone."
            </div>
            <p className="section-text">
              Submitting the form with this checkbox selected constitutes a legally binding agreement to these terms and communications policy.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">7. Warranty & Installation Terms</h2>
            
            <ol className="terms-ordered-list">
              <li>2-year warranty from the date of purchase.</li>
              <li>Warranty covers replacement of faulty parts only. Technician visit/installation charges, if applicable, are not included.</li>
            </ol>
            <p className="section-text" style={{ marginTop: "12px" }}><strong>Installation Terms:</strong></p>
            <ol className="terms-ordered-list">
              <li>The product price includes doorstep delivery only. Installation charges are not included.</li>
              <li>The installation technician will be appointed by the respective City Gas Distribution (CGD) company in your locality.</li>
            </ol>
          </section>

          <section className="terms-section">
            <h2 className="section-title">8. Shipping, Delivery & Refunds</h2>
            <p className="section-text">
              Delivery timelines and order tracking details are provided upon order confirmation. For purchases made through external partners (e.g. Flipkart), their respective shipping, cancellation, and return policies will apply. For direct transactions, products are dispatched within 7–14 working days.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">9. Limitation of Liability</h2>
            <p className="section-text">
              PEARL PRINT PACK PRIVATE LIMITED (RealFlame) shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use our website or services. This includes service disruptions on third-party platforms such as WhatsApp (Meta API outages), courier delays, or internet connectivity issues.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">10. Intellectual Property Rights</h2>
            <p className="section-text">
              All content on this website—including logos, product designs, brand names, text, graphics, and images—is the exclusive intellectual property of PEARL PRINT PACK PRIVATE LIMITED. Unauthorized reproduction, modification, or distribution of any site content is strictly prohibited.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">11. Governing Law & Jurisdiction</h2>
            <p className="section-text">
              These Terms & Conditions are governed by and construed in accordance with the laws of India. Any disputes arising in connection with these terms or site usage shall be subject to the exclusive jurisdiction of the competent courts located in Haridwar, Uttarakhand, India.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">12. Contact Information for Legal Matters</h2>
            <p className="section-text">
              For any legal inquiries, concerns, or notices regarding these Terms & Conditions, please contact us:
            </p>
            <div className="terms-contact-box">
              <p><strong>PEARL PRINT PACK PRIVATE LIMITED</strong></p>
              <p><strong>Registered Office:</strong> Plot No. 12, Sector – IIDC, Haridwar, Uttarakhand 249403, India</p>
              <p><strong>Email:</strong> <a href="mailto:info@realflame.in" className="policy-link">info@realflame.in</a></p>
              <p><strong>Phone:</strong> <a href="tel:+917310777481" className="policy-link">+91 73107 77481</a></p>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

const styles = `
  .terms-container {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 40px var(--left-right-padding);
    font-family: var(--font-family-tertiary);
    background-color: var(--color-7, #FFFFFF);
  }

  .terms-content {
    width: 100%;
    max-width: 1000px;
    padding: var(--spacing-4) 0;
    color: #1F1F1F;
  }

  .policy-title {
    font-family: var(--font-family-primary);
    font-size: 32px;
    font-weight: 700;
    color: #F58220;
    margin-bottom: 8px;
  }

  .policy-last-updated {
    font-size: 14px;
    color: #666666;
    margin-bottom: 32px;
  }

  .terms-section {
    margin-bottom: 32px;
    padding: 0;
  }

  .section-title {
    font-family: var(--font-family-primary);
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #F58220;
    border-bottom: 2px solid #F8F8F8;
    padding-bottom: 6px;
  }

  .section-text {
    font-size: 15px;
    line-height: 1.8;
    margin-bottom: 12px;
    color: #444444;
  }

  .terms-list {
    list-style-type: disc;
    padding-left: 24px;
    margin-bottom: 16px;
  }

  .terms-list li {
    font-size: 15px;
    line-height: 1.7;
    margin-bottom: 8px;
    color: #444444;
  }

  .terms-ordered-list {
    list-style-type: decimal;
    padding-left: 24px;
    margin-bottom: 16px;
  }

  .terms-ordered-list li {
    font-size: 15px;
    line-height: 1.7;
    margin-bottom: 8px;
    color: #444444;
  }

  .policy-link {
    color: #F58220;
    text-decoration: none;
    font-weight: 500;
  }

  .policy-link:hover {
    text-decoration: underline;
    color: #E97700;
  }

  .consent-clause-box {
    background: #FFF8F2;
    border: 1px solid #F58220;
    padding: 16px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-style: italic;
    color: #1F1F1F;
    margin: 16px 0;
  }

  .terms-contact-box {
    background: #F8F8F8;
    border-left: 4px solid #F58220;
    padding: 20px;
    border-radius: 8px;
    margin-top: 16px;
  }

  .terms-contact-box p {
    margin-bottom: 8px;
    font-size: 15px;
  }

  @media (max-width: 768px) {
    .policy-title {
      font-size: 26px;
    }
    
    .section-title {
      font-size: 19px;
    }
    
    .section-text, .terms-list li {
      font-size: 14px;
    }
  }
`;

const TermsAndConditionsWithStyles = () => {
  return (
    <>
      <SEOHead
        title={PAGE_SEO.terms.title}
        description={PAGE_SEO.terms.description}
        keywords={PAGE_SEO.terms.keywords}
        canonical={PAGE_SEO.terms.canonical}
        ogImage={PAGE_SEO.terms.ogImage}
        noIndex={false}
      />
      <style>{styles}</style>
      <TermsAndConditions />
    </>
  );
};

export default TermsAndConditionsWithStyles;